import { ButtonERP, TagERP } from "@finanedi.es/storybook"
import { IEstadoDescripcion } from "api/Commands/UpdateConfiguracionAntifraudeCommand"
import { Trans, useTranslation } from "react-i18next"
import { frontendDateFormat } from "utils/formatDate"

interface VerifactuActiveProps {
  showCard: boolean
  estadoDescripcion: string
  fechaInicioVerifactu: Date
  fechaFinVerifactu: Date
  estadoRevisionDocumentacion?: IEstadoDescripcion
  motivoRechazo?: string
  toggleOpenModal: () => void
}

export const VerifactuActive = ({
  showCard,
  estadoDescripcion,
  fechaInicioVerifactu,
  fechaFinVerifactu,
  estadoRevisionDocumentacion,
  motivoRechazo,
  toggleOpenModal,
}: VerifactuActiveProps) => {
  const { t } = useTranslation()

  if (!showCard) return

  const CURRENT_DATE = fechaInicioVerifactu
    ? frontendDateFormat(fechaInicioVerifactu)
    : ""
  const CURRENT_DATE_END = fechaFinVerifactu
    ? frontendDateFormat(fechaFinVerifactu)
    : ""

  const esRechazado = estadoRevisionDocumentacion?.description === "Rechazado"
  const esPendiente = estadoRevisionDocumentacion?.description === "Pendiente"
  const mostrarDescripcion = !esRechazado && !esPendiente

  return (
    <div className='tw-flex tw-flex-col tw-gap-3 tw-text-left'>
      <div className='tw-flex tw-flex-col tw-gap-2'>
        <div className='tw-flex tw-items-center tw-gap-2'>
          <span className='tw-font-medium'>Tipo:</span>
          <TagERP
            color='green'
            value={estadoDescripcion}
          />
        </div>
        {estadoRevisionDocumentacion && (
          <div className='tw-flex tw-items-center tw-gap-2'>
            <span className='tw-font-medium'>Estado del documento:</span>
            <TagERP
              color={esPendiente ? "orange" : esRechazado ? "red" : "green"}
              value={estadoRevisionDocumentacion?.description}
            />
          </div>
        )}
      </div>

      {esRechazado && motivoRechazo && (
        <div className='tw-flex tw-gap-2'>
          <span className='tw-font-medium'>Motivo de rechazo:</span>
          <span className='tw-text-red-600'>{motivoRechazo}</span>
        </div>
      )}

      {mostrarDescripcion && (
        <div>
          <Trans
            i18nKey='verifactu.configCard.statusActive.description'
            values={{ year: fechaFinVerifactu.getFullYear() }}
            components={[
              <span
                className='tw-font-medium tw-contents !tw-m-0'
                key='0'
              />,
            ]}
          />
        </div>
      )}
      {esPendiente && (
        <div>
          <Trans
            i18nKey='verifactu.configCard.statusPendingValidation.description'
            components={[
              <span
                className='tw-font-medium tw-contents !tw-m-0'
                key='0'
              />,
            ]}
          />
        </div>
      )}

      {esRechazado && (
        <div className='tw-flex tw-items-center tw-justify-between tw-gap-4'>
          <div>
            <Trans
              i18nKey='verifactu.configCard.statusRejected.description'
              components={[
                <span
                  className='tw-font-medium tw-contents !tw-m-0'
                  key='0'
                />,
              ]}
            />
          </div>
          <ButtonERP
            type='button'
            customize={{
              type: "primary",
              size: "md",
            }}
            onClick={() => toggleOpenModal()}
            label={`${t("verifactu.configCard.statusExeption.buttonLabel")}`}
          />
        </div>
      )}

      {mostrarDescripcion && (
        <div className='tw-flex tw-gap-2'>
          <span className='tw-font-medium'>Periodo de validez:</span>
          <span>{`${CURRENT_DATE} - ${CURRENT_DATE_END}`}</span>
        </div>
      )}
    </div>
  )
}
